import React from 'react';
import './signup.css';

function Signup(props){
	return(
		<div>
  		<form method="POST" id="signupId" action="https://www.mesfix.com/users/signupNew">
			<div className="container-landing-signup">
				<div >
					<div className="padding-landing-signup">
						<div className="row-position content-img-landing-signup">
							<div className="section-a-landing-signup content-register column align-center">
								<div className="rectangle-signup">
									<div className={props.personType === 0 ? "section-blue bg-blue-15 column align-center" : "section-blue-short animation-section-blue bg-blue-15 column align-center"}>
										<div className={props.personType === 0 ? "title-section-blue column align-center" : "title-section-blue animation-title column align-center"}>
											<h1 className="title-signup medium">Regístrate</h1>
											<div className="main-description">¿Eres una persona natural o jurídica?</div>
										</div>
										<div className={props.personType === 0 ? "section-type-person" : "section-type-person-short"} >
											<div className="pd-section-type-person justify-between">
												<div className="column align-center">
													<img src={(props.personType === 0 || props.personType === 2) ? "http://images.mesfix.com/images/tec/signup/naturalPerson.svg" : "http://images.mesfix.com/images/tec/signup/naturalPersonOpacity.svg"} data-param="natural" onClick={(evt) => props.selectPersonType(evt)} className={props.personType === 0 ? "icon-person cursor" : "icon-person-small cursor"} alt="icono persona natural"/>
													<div className={props.personType === 0 ? "text-person cursor": props.personType === 1 ? "text-opacity cursor" : "text-person-small normal cursor"}  data-param="natural" onClick={(evt) => props.selectPersonType(evt)}>Persona natural</div>
												</div>
												<div className="column align-center">
													<img src={(props.personType === 0 || props.personType === 1) ? "http://images.mesfix.com/images/tec/signup/legalPerson.svg" : "http://images.mesfix.com/images/tec/signup/legalPersonOpacity.svg"} data-param="legal" onClick={(evt) => props.selectPersonType(evt)} className={props.personType === 0 ? "icon-person cursor" : "icon-person-small cursor"} alt="icono persona legal"/>
													<div className={props.personType === 0 ? "text-person cursor" : props.personType === 2 ? "text-opacity cursor" : "text-person-small cursor"} data-param="legal" onClick={(evt) => props.selectPersonType(evt)}>Persona jurídica</div>
												</div>
											</div>
										</div>
										<input type="hidden" name="personType" value={props.personType} />
										{props.personType === 0 && 
											<div className="section-login">
												<div className="text-account text-login">¿Ya tienes una cuenta? <a href="https://www.mesfix.com/ms/general/loginAccount" className="color-white medium cursor">Inicia sesión</a></div>
											</div>
										}
									</div>
									{props.personType !== 0 ? 
										<div className="padding-rectangle-signup">
											<div className="section-description-signup column align-center">
												<h2 className="normal mg-text-small">Regístrate</h2>
												<p className="description-signup mg-text color-black text-align-center">Crea tu cuenta para comprar o vender activos financieros.</p>
												<h5 className="normal mg-text color-black text-login">¿Ya tienes una cuenta? <a href="https://www.mesfix.com/ms/general/loginAccount" className="color-blue-15 medium cursor">Inicia sesión</a></h5>
											</div>
											<input type="hidden" value="invertir" name="intention" />
											{props.personType === 2 ?
												<div className="content-type-person">
													
													<div className="group-dialog-select mg-between-fields">      
														<div className="select">
															<select className="select-text" name="documentType" onChange={props.handleChange} defaultValue="" required>
																<option value="" disabled></option>
							 									<option value="c.c.">Cédula de ciudadanía</option>
							 									<option value="c.e.">Cédula de extranjería</option>
							 									<option value="passport">Pasaporte</option>
															</select>
															<span className="select-highlight"></span>
															<span className="select-bar"></span>
															<label className="select-label">Tipo de documento</label>
														</div>
													</div>
													<div className="group-signup">
														<input type="text" className="input-middle-signup" name="documentNumber" value={props.documentNumber} onChange={props.handleChange} autoComplete="off" required />
														<span className="highlight"></span>
														<span className="bar"></span>
														<label className="signup">Número de documento</label>
													</div>
													<div className="group-signup">
														<input type="text" className="input-middle-signup" name="firstName" onChange={props.handleChange} title="El formato debe tener mínimo 2 carácteres. No puede contener números" required />
														<span className="highlight"></span>
														<span className="bar"></span>
														<label className="signup">Nombre(s)</label>
													</div>
													<div className="group-signup">
														<input type="text" className="input-middle-signup" name="lastName" onChange={props.handleChange} title="El formato debe tener mínimo 2 carácteres. No puede contener números" required />
														<span className="highlight"></span>
														<span className="bar"></span>
														<label className="signup">Apellido(s)</label>
													</div>
												</div>
											:props.personType === 1 ?
												<div className="content-type-person">
													<div className="group-signup">
														<input type="text" className="input-middle-signup input-icon" name="documentNumber" value={props.documentNumber} minLength="8" maxLength="9" onChange={props.handleChange} autoComplete="off" required />
														<span className="highlight"></span>
														<span className="bar"></span>
														<label className={props.inputValid ? "signup input-invalid" : "signup label-error"}>NIT</label>
														{!props.inputValid &&
															<div className="error-message">No se ha alcanzado el número mínimo de digítos.</div>
														}
														<div className="div-guide">{props.placeholderNit}</div>
													</div>
													<input type="hidden" name="documentType" value={props.documentType} />
													{props.documentNumber.length >= 8 && 
														<div className="group-signup group-no-input">
															<label className="label-no-input">Confirmación de NIT</label>
															<div className="text-no-input-black">{props.documentNumber} - {props.calculateDv(props.documentNumber)} </div>
														</div>
													}
													
												</div>
											:null
										}
										{(props.personType === 2 || props.personType === 1) &&
											<div>
												<div className="group-signup">
													<input type="tel" className="input-middle-signup" name="cellPhone" maxLength="10" onChange={props.handleChange} autoComplete="new-phone" title="La información no puede contener letras y debe tener mínimo 7 números" required />
													<span className="highlight"></span>
													<span className="bar"></span>
													<label className={props.inputValidCellPhone ? "signup input-invalid" : "signup label-error"}>Celular</label>
													{!props.inputValidCellPhone  &&
														<div className="error-message">Ingresa un número de 10 dígitos.</div>
													}
												</div>
												<div className="group-signup">
													<input type="text" className="input-middle-signup" name="email" onChange={props.handleChange} required />
													<span className="highlight"></span>
													<span className="bar"></span>
													<label className="signup">Correo electrónico</label>
												</div>
												{props.re.test(props.email) &&
													<div className="group-signup group-no-input">
														<label className="label-no-input">Confirmación de correo</label>
														<div className="text-no-input-black">{props.email}</div>
													</div>
												}
												<div className="section-captcha justify-center align-center">
													<div id="captchaId" className="g-recaptcha" data-sitekey="6LcWpWYUAAAAAH1odGWmfOh2WN1gLqYwsEIfwshJ"></div>
												</div>
												<div className="section-checkbox-data-policy justify-center">
													<a href="https://drive.google.com/file/d/0B3DQfy7PdZHiV1JXV3hxNTZ6YWc/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="section-data-policy text-align-center color-gray-35">
														Al hacer click en ‘Enviar’ reconozco que acepto las <span className="color-blue-15">Políticas de Tratamiento de Datos</span>
													</a>
												</div>
												<div className="section-btn-signup justify-center">
													<button type="submit" className="btn-signup cursor bg-blue-15 medium">
														ENVIAR
													</button>

												</div>
											</div>
										}
									</div>


									:null } 
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
	)
}

export default Signup